import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { SetImageInd } from "../../../StateManagement/Reducers/LoginState";
import { GetLogo } from "../../../StateManagement/Reducers/PreLoginState";

import SlideImage from "./SlideImage";
import Banner from "../../../Assets/images/PatientportalLoginscreen.svg";
import { ImageContainer, Image } from "../StyledComponents";
import LoginBG from "../../../Assets/images/LoginBG.svg";
import GreenTick from "../../../Assets/images/GreenTick.svg";

// import { Container } from "../StyledComponents";
// import {
//   Curcle,
//   CurcleMiddle,
//   CurcleStart,
//   TextLabel,
//   ActiveSlideContainer,
//   ActiveSlide,
// } from "./styles";

// import Slider_1 from "../../../Assets/images/login_slide.png";
// import Slider_2 from "../../../Assets/images/login_slide_2.png";
// import Slider_3 from "../../../Assets/images/login_slide_3.png";

const LoginLeft = () => {
  const dispatch = useDispatch();

  // const ImageInd = useSelector((state) => state.Login.ImageInd);

  // const ImageVal = [Slider_1, Slider_2, Slider_3];
  // const LabelVal = ["", "", ""];

  useEffect(() => {
    dispatch(GetLogo());
  }, [dispatch]);

  // useEffect(() => {
  //   const Timer = setTimeout(() => {
  //     dispatch(SetImageInd(ImageInd));
  //   }, 3000);
  //   return () => clearTimeout(Timer);
  // });

  return (
    <>
      {/* <Container>
        <Curcle></Curcle>
        <CurcleMiddle></CurcleMiddle>
        <CurcleStart></CurcleStart>
      </Container>
      <SlideImage ImageUrl={ImageVal[ImageInd]} />
      <TextLabel>{LabelVal[ImageInd]}</TextLabel>
      <ActiveSlideContainer>
        {ImageVal.map((dot, ind) => (
          <ActiveSlide
            onClick={() => dispatch(SetImageInd(ind - 1))}
            active={ind === ImageInd}
            key={ind}
          ></ActiveSlide>
        ))}
      </ActiveSlideContainer> */}

      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100vh",
          backgroundImage: `url(${LoginBG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          overflow: "hidden",
        }}
      >
        {/* BLUE OVERLAY */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            // background: "rgba(34, 64, 164, 0.88)",
            zIndex: 1,
          }}
        />

        {/* CONTENT */}
        <div
          style={{
            position: "relative",
            zIndex: 2,
            padding: "20px 50px",
            color: "#fff",
            maxWidth: "540px",
          }}
        >
          {/* Heading */}
          <div
            style={{
              fontSize: "35px",
              fontWeight: "700",
              lineHeight: "45px",
              marginBottom: "10px",
            }}
          >
            Stay Connected to Your Health and Your Provider
          </div>

          {/* Description */}
          <div
            style={{
              fontSize: "18px",
              lineHeight: "24px",
              marginBottom: "10px",
              // opacity: "0.95",
              fontStyle: "italic",
              fontWeight: "500",
              width: "540px",
              marginRight: "-160px",
            }}
          >
            Securely log in to your Client Portal by entering your credentials
            to access your health dashboard. By accessing this client portal,
            you can:
          </div>

          {/* Bullet list */}
          <div
            style={{ display: "flex", flexDirection: "column", gap: "15px" }}
          >
            {[
              "View Your Health Records",
              "Book & Manage Appointments",
              "Securely Message Your Provider",
              "Pay Medical Bills Online",
              "Access Telehealth Visits",
              "Download & Share Health Documents",
              "HIPAA-compliant. Encrypted. Secure login authentication.",
            ].map((text, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  fontSize: "16px",
                }}
              >
                <img src={GreenTick} alt="tick" width="20" height="20" />
                <span>{text}</span>
              </div>
            ))}
          </div>

          {/* Footer */}
          <div
            style={{
              marginTop: "10px",
              fontSize: "18px",
              lineHeight: "28px",
              fontWeight: "500",
              width: "540px",
              marginRight: "-160px",
            }}
          >
            No complicated steps. Just safe, instant access to your health
            information whenever you need it.
          </div>
          {/* <img
        src={Banner}
        alt="Patient Portal Banner"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "top center",
          display: "block",
        }}
      /> */}
        </div>
      </div>
    </>
  );
};

export default LoginLeft;
